export enum ExcludableTextboxOrientation {
    STACKED = "stacked",
    INLINE = "inline"
}
